'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var react = require('react');
require('../../../_virtual/_tslib.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('@wishket/yogokit');
require('react-dom');
require('../../DataDisplays/Avatar/Avatar.js');
require('../../DataDisplays/Label/Label.js');
var SystemIcon = require('../../DataDisplays/SystemIcon/SystemIcon.js');
require('next/link');
var RichTooltip = require('../../Feedbacks/RichTooltip/RichTooltip.js');

/**
 * 정보 아이콘과 함께 리치 툴팁을 표시하는 래퍼 컴포넌트입니다.
 *
 * @component
 * @param {Object} props - 컴포넌트 프로퍼티
 * @param {'sm' | 'md'} [props.size='md'] - 정보 아이콘의 크기 (sm, md)
 * @param {'right' | 'down'} [props.variant='right'] - 툴팁이 표시될 방향 (right, down)
 * @param {string} [props.title] - 툴팁의 제목
 * @param {string} [props.description] - 툴팁의 설명 텍스트
 * @param {React.ReactNode} [props.children] - 툴팁 내부에 표시될 컨텐츠
 * @param {string} [props.className] - 툴팁 컨테이너에 적용될 추가 클래스
 *
 * @example
 * // 기본 사용법
 * <WithRichTooltip
 *   title="결제 정보"
 *   description="신용카드 또는 계좌이체로 결제가 가능합니다."
 * />
 *
 * // 크기와 방향 지정
 * <WithRichTooltip
 *   size="sm"
 *   variant="down"
 *   title="배송 안내"
 *   description="주문 후 1-3일 내 배송됩니다."
 * >
 *   <p>추가 배송 정보는 여기에 표시됩니다.</p>
 * </WithRichTooltip>
 */ const WithRichTooltip = ({ size = 'md', variant = 'right', title, description, children, className })=>{
    const iconName = size === 'md' ? 'medium_information' : 'small_information';
    const isOnRight = variant === 'right';
    const isOnDown = variant === 'down';
    const [isHovered, setIsHovered] = react.useState(false);
    return jsxRuntime.jsxs(Box, {
        className: "relative h-fit w-fit",
        "data-testid": "design-system-withRichTooltip",
        children: [
            jsxRuntime.jsx(Box, {
                "data-testid": "design-system-withRichTooltip--trigger",
                className: "flex h-fit w-fit shrink-0 items-center justify-center",
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                onClick: ()=>setIsHovered((pre)=>!pre),
                children: jsxRuntime.jsx(SystemIcon, {
                    name: iconName,
                    className: "text-w-gray-400",
                    testId: size === 'md' ? 'design-system-withRichTooltip--trigger-icon-md' : 'design-system-withRichTooltip--trigger-icon-sm'
                })
            }),
            isHovered && jsxRuntime.jsx(RichTooltip, {
                title: title,
                description: description,
                className: tailwindMerge.twMerge('absolute', isOnRight && 'left-[calc(100%_+_12px)] top-0', isOnDown && 'left-0 top-[calc(100%_+_12px)]', className),
                children: children
            })
        ]
    });
};

module.exports = WithRichTooltip;
